module.exports = __webpack_public_path__ + "img/icon_已认证@3x.a526db8a.png";